module.exports = "/images/vendor/flag-icon-css/flags/1x1/um.svg?3d347682d5c526a37719f5ab8a890f11";